const Config = (): any => {
  const maxNotificationMessages = 10;
  const errorCodeForFrontEnd = "liberaworks-web";
  const errorCodeForBackEnd = "liberaworks-server";
  const delayTimeAppNotificationMessage = 5000;

  if (process.env.REACT_APP_LIBERA_ENV === "dev") {
    return {
      frontEnd: {
        uploadFileMaxSize: 10485760,
        uploadActivityFileMaxSize: 104857600,
        defaultOffset: 10,
        defaultPageRangeDisplayed: 5,
        sidebarPcSize: 3,
        mainPcSize: 9,
        sidebarMobileSize: 12,
        mainMobileSize: 12,
        projectsCardPcSize: 6,
        projectsCardMobileSize: 12,
        customerCardOccupationsPcMax: 5,
        customerCardOccupationsSpMax: 2,
        maxNotificationMessages,
        errorCodeForFrontEnd,
        delayTimeAppNotificationMessage,
        adminURL: "https://liberaworks-admin-dev.firebaseapp.com",
        projectId: "liberaworks-dev",
      },
      backEnd: {
        baseURL: process.env.REACT_APP_DEV_BE_URL,
        errorCodeForBackEnd,
      },
      fireBase: {
        apiKey: process.env.REACT_APP_DEV_FB_API_KEY,
        authDomain: process.env.REACT_APP_DEV_FB_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_DEV_FB_DATABASE_URL,
        projectId: process.env.REACT_APP_DEV_FB_PROJECT_ID,
        storageBucket: process.env.REACT_APP_DEV_FB_STORAGE_BUCKET,
        messagingSender_Id: process.env.REACT_APP_DEV_FB_MESSAGING_SENDER_ID,
      },
    };
  } else if (process.env.REACT_APP_LIBERA_ENV === "prod") {
    return {
      frontEnd: {
        uploadFileMaxSize: 10485760,
        uploadActivityFileMaxSize: 104857600,
        defaultOffset: 10,
        defaultPageRangeDisplayed: 5,
        sidebarPcSize: 3,
        mainPcSize: 9,
        sidebarMobileSize: 12,
        mainMobileSize: 12,
        projectsCardPcSize: 6,
        projectsCardMobileSize: 12,
        customerCardOccupationsPcMax: 5,
        customerCardOccupationsSpMax: 2,
        maxNotificationMessages,
        errorCodeForFrontEnd,
        delayTimeAppNotificationMessage,
        adminURL: "https://admin.expert-network.io",
        projectId: "liberaworks-prod",
      },
      backEnd: {
        baseURL: process.env.REACT_APP_PROD_BE_URL,
        errorCodeForBackEnd,
      },
      fireBase: {
        apiKey: process.env.REACT_APP_PROD_FB_API_KEY,
        authDomain: process.env.REACT_APP_PROD_FB_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_PROD_FB_DATABASE_URL,
        projectId: process.env.REACT_APP_PROD_FB_PROJECT_ID,
        storageBucket: process.env.REACT_APP_PROD_FB_STORAGE_BUCKET,
        messagingSender_Id: process.env.REACT_APP_PROD_FB_MESSAGING_SENDER_ID,
      },
    };
  } else {
    return {
      // 指定なしの場合は環境変数から取得で動作
      frontEnd: {
        uploadFileMaxSize: 10485760,
        uploadActivityFileMaxSize: 104857600,
        defaultOffset: 10,
        defaultPageRangeDisplayed: 5,
        sidebarPcSize: 3,
        mainPcSize: 9,
        sidebarMobileSize: 12,
        mainMobileSize: 12,
        projectsCardPcSize: 6,
        projectsCardMobileSize: 12,
        customerCardOccupationsPcMax: 5,
        customerCardOccupationsSpMax: 2,
        maxNotificationMessages,
        errorCodeForFrontEnd,
        delayTimeAppNotificationMessage,
      },
      backEnd: {
        baseURL: process.env.REACT_APP_BE_URL,
        errorCodeForBackEnd,
      },
      fireBase: {
        apiKey: process.env.REACT_APP_FB_API_KEY,
        authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
        projectId: process.env.REACT_APP_FB_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
        messagingSender_Id: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
      },
    };
  }
};

export const fireBaseConfig = Config().fireBase;
export const backEndConfig = Config().backEnd;
export const frontEndConfig = Config().frontEnd;



// WEBPACK FOOTER //
// ./src/config/config.ts